var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@marketing/components/global/CTA/Button';
import FlexSection from '@marketing/components/sections/FlexSection';
import useTicker from '@marketing/useTicker';
import { clsx } from 'clsx';
import { Link } from 'react-router';
import ScallopedImageItem from './Items/ScallopedImageItem';
function RTBWithImages(_a) {
    var backgroundColorStyle = _a.backgroundColorStyle, content = _a.content, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b;
    var rtbItems = content.rtbItems, tickerText = content.tickerText, ctaUrl = content.ctaUrl, buttonLabel = content.buttonLabel;
    var RTBComponent = (_jsxs(FlexSection, __assign({ backgroundColorStyle: backgroundColorStyle, paddingStyle: "px-xs-m pb-xl-m md:px-lg-gutter md:pb-md-page-bottom-web", className: "md:!flex-col" }, { children: [_jsx("div", __assign({ className: clsx('flex flex-col md:flex-row w-full justify-start md:justify-between gap-[60px] py-xl-m md:py-[60px]') }, { children: rtbItems.map(function (item, index) { return (_jsx(ScallopedImageItem, __assign({ theme: theme, borderTheme: 'light' }, item), index)); }) })), ctaUrl && buttonLabel && (_jsx(Link, __assign({ to: ctaUrl, viewTransition: true, className: "hover:no-underline self-center" }, { children: _jsx(Button, { label: buttonLabel, use: "secondary", size: "small" }) })))] })));
    return useTicker(RTBComponent, tickerText, backgroundColorStyle, theme, 'border-border-shoe');
}
export default RTBWithImages;
